import React, { useEffect } from 'react'

import { useTheme } from '@mui/material'
import { IconButton, CircularProgress, Typography, Card } from '@mui/material'
import {
    Description,
    AssignmentLate,
    Launch,
    NewReleases,
} from '@mui/icons-material'

import { FlexDiv } from '../../components'
import { useReports } from '../../hooks/useReports'

export const Reports = () => {
    const theme = useTheme()

    const { reportList, getReportList, isLoading, markReportAsViewed } =
        useReports()

    useEffect(() => {
        getReportList()
    }, [])

    const handleViewReport = (report: any) => {
        if (!report.tenant_viewed) {
            markReportAsViewed(report.id)
        }
        if (report.report) {
            window.open(report.report, '_blank')
        }
    }

    return (
        <FlexDiv
            direction="column"
            style={{
                padding: theme.spacing(2),
            }}
        >
            <FlexDiv style={{ marginBottom: theme.spacing(2) }}>
                <Description
                    style={{
                        color: theme.palette.primary.main,
                        marginRight: theme.spacing(1),
                        fontSize: '2rem',
                    }}
                />
                <Typography
                    variant="h4"
                    style={{
                        fontWeight: 500,
                        color: theme.palette.primary.main,
                    }}
                >
                    Reports
                </Typography>
            </FlexDiv>

            <Typography
                variant="body1"
                style={{
                    marginBottom: theme.spacing(3),
                    color: theme.palette.text.secondary,
                }}
            >
                View your damage reports here.
            </Typography>

            {isLoading ? (
                <FlexDiv
                    style={{
                        justifyContent: 'center',
                        padding: theme.spacing(4),
                    }}
                >
                    <CircularProgress
                        size={40}
                        style={{ color: theme.palette.primary.main }}
                    />
                </FlexDiv>
            ) : reportList.length === 0 ? (
                <FlexDiv
                    direction="column"
                    style={{
                        alignItems: 'center',
                        padding: theme.spacing(6),
                        gap: theme.spacing(2),
                    }}
                >
                    <AssignmentLate
                        style={{
                            fontSize: '48px',
                            color: theme.palette.text.disabled,
                        }}
                    />
                    <Typography style={{ color: theme.palette.text.secondary }}>
                        No reports available
                    </Typography>
                </FlexDiv>
            ) : (
                <FlexDiv direction="column" style={{ gap: theme.spacing(2) }}>
                    {reportList.map((report) => (
                        <Card
                            key={report.id}
                            elevation={0}
                            style={{
                                padding: theme.spacing(2.5),
                                borderRadius: '8px',
                                border: `1px solid ${theme.palette.divider}`,
                                backgroundColor: !report.tenant_viewed
                                    ? theme.palette.primary.light
                                    : 'transparent',
                                transition: 'background-color 0.2s ease',
                            }}
                        >
                            {!report.tenant_viewed && (
                                <NewReleases
                                    style={{
                                        position: 'absolute',
                                        top: theme.spacing(1),
                                        right: theme.spacing(1),
                                        fontSize: '16px',
                                        color: theme.palette.primary.main,
                                    }}
                                />
                            )}
                            <FlexDiv
                                style={{
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                }}
                            >
                                <FlexDiv
                                    direction="column"
                                    style={{ gap: theme.spacing(0.5) }}
                                >
                                    <Typography
                                        style={{
                                            fontSize: '1rem',
                                            fontWeight: !report.tenant_viewed
                                                ? 500
                                                : 400,
                                            color: theme.palette.text.primary,
                                            lineHeight: 1.5,
                                        }}
                                    >
                                        {report.name}
                                    </Typography>
                                    <Typography
                                        style={{
                                            fontSize: '0.875rem',
                                            color: theme.palette.text.secondary,
                                        }}
                                    >
                                        Created on:{' '}
                                        {new Date(
                                            report.creation_time,
                                        ).toLocaleDateString()}
                                    </Typography>
                                </FlexDiv>
                                <IconButton
                                    onClick={() => handleViewReport(report)}
                                    style={{
                                        backgroundColor:
                                            theme.palette.primary.main,
                                        padding: '8px',
                                        color: theme.palette.primary
                                            .contrastText,
                                        marginLeft: theme.spacing(1),
                                    }}
                                >
                                    <Launch />
                                </IconButton>
                            </FlexDiv>
                        </Card>
                    ))}
                </FlexDiv>
            )}
        </FlexDiv>
    )
}
